import React, { useState, useEffect } from 'react'
import styles from './class-card.scss'
import ClassCard from './class-card'
import { useHistory } from 'react-router-dom'

const ClassList = ({ blankTitle, dataSource, linkUrl, onModal }) => {
  const history = useHistory()
  const handleIntoClass = classId => {
    history.push(linkUrl + classId)
  }
  return (
    <div className={styles.cardContainer}>
      <div onClick={onModal}>
      <ClassCard addClass={blankTitle} />
      </div>
      {
        dataSource.map(item => (
          <div key={item.id} onClick={() => handleIntoClass(item.id)}>
            <ClassCard classInfo={item} />
          </div>
        ))
      }
    </div>
  )
}

export default ClassList
